<template>
  <div class="of-service-remind home-top-remind" v-if="isShow">
    <xin-icon xin-type="icon_tips_standard" class="m_r4" />
    <div class="notice-close c_pointer" @click="isShow = false">
      <xin-icon xin-type="close" class="sk--hover-text"></xin-icon>
    </div>
    <p class="msg-text">{{ofServiceMsg}}</p>
  </div>
</template>

<script lang="ts">
  import { Component, Vue } from 'vue-property-decorator';
  import {namespace} from 'vuex-class';
  const moduleInfra = namespace('moduleInfra');

  @Component({})
  export default class OfServiceRemind extends Vue {

    @moduleInfra.Getter('getSlaMsg') public ofServiceMsg!: string;
    // ofServiceMsg = "尊敬的客户，我们将于周五04月14日22:00-次日凌晨00:00对员工模块进行升级。升级过程中员工模块相关功能将暂停使用，请您提前安排好工作，给您带来的不便敬请谅解！"
    isShow = false

    created(){
      this.isShow = !!this.ofServiceMsg
    }

 }
</script>

<style lang="scss" scoped>
.of-service-remind {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  padding: 0 32px;
  background: #FFF4F4;
  font-size: 12px;
  font-weight: 400;
  color: #3D3D3D;
  .xin-icon{
    font-size: 13px;
    color: #F73838;
  }
  .notice-close{
    position: absolute;
    right: 8px;
    .xin-icon{
      color: var(--xs-text-color-gray);
    }
  }
}
</style>
